import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromCustomerDetailState from './customer-detail.reducer';
import { CustomerDetailEffects } from './customer-detail.effects';

@NgModule({
	imports: [
		StoreModule.forFeature(
			fromCustomerDetailState.customerDetailFeatureKey,
			fromCustomerDetailState.reducer
		),
		EffectsModule.forFeature([CustomerDetailEffects]),
	],
})
export class CustomerDetailStateModule {}
